import { render, staticRenderFns } from "./MicroPageNavigation.vue?vue&type=template&id=5d704277&scoped=true&"
import script from "./MicroPageNavigation.vue?vue&type=script&lang=js&"
export * from "./MicroPageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MicroPageNavigation.vue?vue&type=style&index=0&id=5d704277&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d704277",
  null
  
)

export default component.exports